import * as React from "react";
import { Redirect } from "react-router-dom";
import SortableTbl from "react-sort-search-table";
import Loader from 'react-loader';
import { toast, ToastContainer} from 'react-toastify';
import {Button,Col, Input, Row} from 'reactstrap';

import Navbar from '../../../../components/CustomNav/CustomNav.Component';
import withServices  from '../../../../HOCs/withServices';
import { Wrapper, Content , ContentRow} from './ListVariables.styles'

interface IProps {
    services?: any;
    location?: any;
    match?: any;
    history?: any;
}
  
interface IState {
    toLogin: boolean;
    loaded: boolean;
    data: any;
    selectedLesson: string;
    isNavigate: boolean;
    destination: string;
}

class ListIcons extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
    
        this.state = {
          destination: '',
          toLogin: false,
          loaded: true,
          isNavigate: false,
          data: {},
          selectedLesson: '',
        };
    
        this.onLogout = this.onLogout.bind(this);
        this.onGoBack = this.onGoBack.bind(this);
        this.goToInteractionEdit = this.goToInteractionEdit.bind(this);
        this.onGoToCreate = this.onGoToCreate.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    public onGoBack() {
        const dest = this.props.services.currentBaseUrl + 'home/';
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public onGoToCreate() {
        const dest = this.props.services.currentBaseUrl + 'interactions_creator';
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public handleChange(rowData, e) {

        rowData.Value = e.target.value;

        this.forceUpdate()

        console.log(rowData.Value);
    }

    public onLogout() {
        this.setState({ toLogin: true });
    }

    public async goToInteractionEdit(row) {
        console.log(row);
        const dest = this.props.services.currentBaseUrl + 'interactions/' + row.rowData.id
        
        console.log(dest)
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public async update(row) {
        console.log(row.rowData.SystemVariableId);

        const retVal = confirm("Do you want to continue ? Some Changes will take effect after system restart");
    
        if(retVal === true) {
                  console.log('edit accepted');
                  const res = await this.props.services.adminAPI.updateItemGeneral('system_variables', row.rowData, row.rowData.SystemVariableId);
                  if (res.ok) {

                    const assetCollectionsRes = await this.props.services.adminAPI.getSystemVariables();

                    if (assetCollectionsRes.ok) {
            
                        const collections = assetCollectionsRes.data;
                        
                        const data = this.state.data;

                        data.collections = collections;

                        this.setState({data});
                    }
                    
                }
                  return true;
        } else {
            console.log('delete canceled')
            return false;
        }
    }

    public customTD = props =>{
        return (
          <td>
            {/*tslint:disable-next-line jsx-no-lambda*/}
            <input required={true} onChange= {(e) => this.handleChange(props.rowData, e)}  type={props.Type} value={props.rowData.Value}/>

            {/*tslint:disable-next-line jsx-no-lambda*/}
            <button style={{margin: '3px'}} className="blue-button view-more-data table-action" onClick={() => this.update(props)}>Update</button>
          </td>
        );
    } 

    public async componentDidMount() {
        const {
            match,
            history,
            location,
            services: { isUserLoggedIn, adminAPI, currentUserID },
        } = this.props;

        if (!isUserLoggedIn) { this.setState({ toLogin: true }); }

        const { params: { id: InteractionID } } = match;

        const assetCollectionsDataKey = ["SystemVariableId", "Name","delete"];
        
        const assetCollectionsThead = ["ID", "Name", "Value"];


        const assetCollectionsRes = await adminAPI.getSystemVariables();

        if (assetCollectionsRes.ok) {
            
            const collections = assetCollectionsRes.data;

            this.setState(
                {
                     data: {
                        collections,
                        loaded: true,
                        collectionsdatakey: assetCollectionsDataKey,
                        collectionsthead: assetCollectionsThead
                     }
                }
            )
        } else {
            toast.error('Error fetching interaction details!');
        }
    }

    public render() {
        const {data} = this.state;
    
        if (this.state.toLogin) {
          return <Redirect to="/login" />;
        }

        if (this.state.isNavigate) {
            return <Redirect to={this.state.destination} />;
          }
    
        if (Object.keys(data).length === 0) {
          return <Loader color="#acff24" />;
        }

        return (
            <Wrapper>
              <ToastContainer/>
              <Navbar logoutParent={this.onLogout} />
              <Content>
                <ContentRow className="single-col">
                  <p className="go-back" onClick={this.onGoBack}>&lt; Back</p>
                </ContentRow>
              </Content>

              <Content>
                <SortableTbl
                    tblData={data.collections}
                    tHead={data.collectionsthead}
                    dKey={data.collectionsdatakey}
                    customTd={[
                            { custd: this.customTD, keyItem: "edit", sortable: false },
                            { custd: this.customTD, keyItem: "delete", sortable: false }
                        ]}
                    defaultCSS={false}
                />

              </Content>

              
              </Wrapper>
        );

    }

}

export default withServices(ListIcons);


// WEBPACK FOOTER //
// ./src/pages/Admin/SystemVariables/ListVariables/ListVariables.tsx